<template>
  <div class="content dash" style="width: 100%; overflow: auto">
    <b-container fluid>
      <h1>{{ title }}</h1>
      <div class="mt-3">
        <slot></slot>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
h1 {
  font-family: 'Inter', sans-serif;
  font-size: 46px;
  font-weight: 700;
  line-height: 54px;
}

button {
  border: 0.5px solid #333333;
  border-radius: 15px;
  min-width: 160px;
  color: #333333;
}
</style>
